import { Component } from '@angular/core';

@Component({
  selector: 'p-router-outlet',
  template: `
    <router-outlet></router-outlet>
  `,
})
export class RouterOutletComponent {}
